/**
 * School portal: shared width for the sliding aside (profile snapshot + handbook / matrix).
 * Keep in sync with GuidedTour spotlight geometry when the drawer is highlighted.
 */
export const PORTAL_SIDE_DRAWER_WIDTH_PX = 520;

/** CSS length: cap drawer at viewport minus safe-area (phones). */
export const portalDrawerWidthCss = () =>
  `min(${PORTAL_SIDE_DRAWER_WIDTH_PX}px, calc(100vw - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px)))`;

/** Negative edge offset when drawer is closed (must match width expression). */
export const portalDrawerOffscreenEdgeCss = () =>
  `calc(0px - min(${PORTAL_SIDE_DRAWER_WIDTH_PX}px, calc(100vw - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px))))`;
